import { render, staticRenderFns } from "./SectionNavigation.vue?vue&type=template&id=e98ae492&"
import script from "./SectionNavigation.vue?vue&type=script&lang=js&"
export * from "./SectionNavigation.vue?vue&type=script&lang=js&"
import style0 from "./SectionNavigation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports